import { getCurrentClientData } from "@/services/authServices";
import { Navigate, Outlet, useLocation } from "react-router-dom";

interface ProtectedRouteProps {
  children?: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const location = useLocation();
  const loggedInUser = getCurrentClientData();

  // Check if the user is authenticated
  const isAuthenticated = !!loggedInUser.token;

  if (!isAuthenticated) {
    // Redirect to the sign-in page with a return url
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  // If there are children, render them, otherwise render the Outlet
  return children ? <>{children}</> : <Outlet />;
};

export default ProtectedRoute;
